//요청 처리 상태
export enum RequestStatus {
    대기 = "대기",
    승인 = "승인",
    반려 = "반려",
    추가견적 = "추가견적",
    어드민 = '어드민'
}

//요청 종류
export enum RequestType {
    가입 = "가입",
    프로젝트 = "프로젝트",
    작업자 = "작업자"
}

//요청 검색 대상
export enum RequestTarget {
    COMPANY_NAME = 'companyName',
    PROJECT_NAME = 'projectName',
    ALL = 'ALL'
}

//작업자 추가 요청 정렬 기준
export enum WorkerRequestSort {
    //회사명
    COMPANY_ASC = "COMPANY_ASC",
    COMPANY_DESC = "COMPANY_DESC",
    //생성일
    CREATE_ASC = "CREATE_ASC",
    CREATE_DESC = "CREATE_DESC",
    //희망 시작일
    START_ASC = "START_ASC",
    START_DESC = "START_DESC",
    //처리일
    CONFIRM_ASC = "CONFIRM_ASC",
    CONFIRM_DESC = "CONFIRM_DESC",
    //작업자 수
    AMOUNT_ASC = "AMOUNT_ASC",
    AMOUNT_DESC = "AMOUNT_DESC",
}